import React from "react"
import styles from "./Shared.module.css"

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  unit?: string
}

const Input: React.FC<InputProps> = ({ unit, ...props }) => (
  <div className={styles.inputWrapper}>
    <input className={styles.input} {...props} />
    {unit && <span className={styles.inputUnit}>{unit}</span>}
  </div>
)

export default Input
